<script lang="ts">
  import { onMount } from "svelte";
  import { SvelteToast, toast } from "@zerodevx/svelte-toast";
  import {
    ApolloClient,
    gql,
    InMemoryCache,
    createHttpLink,
  } from "@apollo/client";
  import { setContext } from "@apollo/client/link/context";
  import { AppStore } from "./utils/store";
  import Header from "./Header.svelte";
  import { toastDanger } from "./utils/toastDanger";
  import Loader from "./Loader.svelte";
  import Clipboard from "./Clipboard.svelte";

  let isLoading = true,
    noContact = false,
    client,
    backers = [];

  function fetch() {
    isLoading = true;
    client
      .query({
        query: gql`
          {
            backers {
              given_name
              surname
              email
              contribution
              isContact
              given_name
              lang
              key
            }
          }
        `,
      })
      .then(({ data }) => {
        isLoading = false;
        backers = data.backers.sort((a: { isContact: boolean; },b: { isContact: boolean; })=>Number(a.isContact)  - Number(b.isContact));
      })
      .catch((e) => {
        isLoading = false;
        toast.push(e, toastDanger);
      });
  }

  onMount(() => {
    if ($AppStore.token.length === 25) {
      const httpLink = createHttpLink({
        uri: process.env.WORKER_URL,
      });

      const authLink = setContext((_, { headers }) => {
        return {
          headers: {
            ...headers,
            Authorization: $AppStore.token,
          },
        };
      });

      client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache(),
      });

      fetch();
    }
  });

  function handleCheck(key,isContact){
    client
      .mutate({ mutation: gql`
      mutation checkContact(
        $key: String!
        $check: Boolean!
      ) {
        checkContact(
          key: $key
          check: $check
        ) {
          given_name
              surname
              email
              contribution
              isContact
              given_name
              lang
              key
        }
      }
    `, variables:{
      key,
      check:isContact
    } })
      .then(({ data }) => {
        const
          backer = backers.find(it=>it.key === key),
          index = backers.findIndex(it=>it.key === key);
        if(backer){
          console.log(backer)
          backer.isContact = !backer.isContact
          const newBacker = [...backers];
          newBacker.splice(index,1,backer)
          backers = [...newBacker]
        }
        toast.push("backer à jour");
      })
      .catch((e) => {
        toast.push(
          "ça n'a pas marché !",
          toastDanger
        );
      });
  }
  
</script>

<svelte:head>
  <title>ADMIN MICRAL</title>
</svelte:head>

<div class="container">
  <header class="header">
    <Header />
    <button class="button" on:click={fetch}>
      recharger
    </button>
    <button class="button" on:click={()=>noContact = !noContact}>
      Cacher les contactés
    </button>
  </header>
  <main class="main">
    {#if $AppStore.token}
      {#if isLoading}
        <Loader />
      {:else}
        <div class="backers">
          {#each backers.filter(it=>noContact ? !it.isContact  : true) as backer}
            <div class="backer" key={backer.key}>
              <div class="identity">
                <div class="flag">
                  <img src={`/${backer.lang.toLowerCase()}.png`} alt="flag" />
                </div>
                <div class="name">
                  {backer.given_name}
                  {backer.surname}
                </div>
              </div>
              <div class="email">Email:</div>
              <Clipboard
                txt={backer.email}
                typeTxt="input"
              />
              <div class="identity check" on:click={()=>handleCheck(backer.key, !backer.isContact)}>
                <div class="checkbox" data-check={backer.isContact} ></div>
                <div class="txt">contacté</div>
              </div>
              <div class="contrib">{backer.contribution} €</div>
            </div>
          {/each}
        </div>
      {/if}
    {:else}
      <div class="alert">Renseigner le token</div>
    {/if}
  </main>
</div>

<SvelteToast />

<style>
  .container {
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100vh;
    padding: 10px;
    box-sizing: border-box;
  }

  .alert {
    color: #a04e4e;
    text-align: center;
    font-size: 2em;
    padding: 20px;
  }

  .backers {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .backer {
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    flex-direction: column;
    padding: 10px;
    display: flex;
    gap: 10px;
  }

  .flag {
    width: 15px;
  }

  .identity {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 10px;
  }

  .checkbox {
    position: relative;
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-mug);
    border-radius: 3px;    
  }

  .checkbox::after {
    content:"";
    position: absolute;
    top: 2px;
    right: 2px;
    left: 2px;
    bottom:2px;
    transition: 200ms ease-in-out;
    border-radius: 4px;
  }

  .checkbox[data-check="true"]::after{
    background: var(--color-coffee);
  }

  .check {
    cursor: pointer;
  }
  
  .contrib {
    text-align: center;
    opacity: .5;
  }

  .header {
    display: flex;
    justify-items: center;
    gap: 20px;
    align-items: center;
    justify-content: center;
  }
</style>
